/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Pagination_PrevInputs */

const es_admin_traces_pagination_prev = /** @type {(inputs: Admin_Traces_Pagination_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const en_admin_traces_pagination_prev = /** @type {(inputs: Admin_Traces_Pagination_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prev`)
};

/**
* | output |
* | --- |
* | "Prev" |
*
* @param {Admin_Traces_Pagination_PrevInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_pagination_prev = /** @type {((inputs?: Admin_Traces_Pagination_PrevInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Pagination_PrevInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_pagination_prev(inputs)
	return en_admin_traces_pagination_prev(inputs)
});
export { admin_traces_pagination_prev as "admin.traces.pagination.prev" }